import { createSlice } from "@reduxjs/toolkit";

const initialState = {};


export const taskAllocationSlice = createSlice({
    name: "Task-Allocation",
    initialState,
    reducers: {
        changeAcademicCoordinator: (state, action) => {
            const { key, value } = action.payload;
            state[key] = value;
        }
    }

})

export const { changeAcademicCoordinator } = taskAllocationSlice.actions;

export default taskAllocationSlice.reducer;